<template>
  <div>
    <div class="minuta page-break-inside-avoid">
      <div class="block-2">
        <div class="column brd-tl">
          <div class="row row-1">
            <div>
              <span class="field-span font-uppercase">Remetente</span>
            </div>
          </div>
          <div class="row row-1">
            <div>
              <span class="field-span">{{ order.from.name | upper }}</span>
            </div>
          </div>
          <div class="row row-1">
            <div>
              <span class="field-span">{{ order.from.address | upper }}, {{ order.from.location_number | upper }}</span>
            </div>
          </div>
          <div class="row row-1">
            <div>
              <span class="field-span">{{ order.from.complement | upper }}</span>
            </div>
          </div>
          <div class="row row-1">
            <div>
              <span class="field-span">{{ order.from.district | upper }}</span>
            </div>
          </div>
          <div class="row row-1">
            <div>
              <span class="field-span">{{ order.from.city | upper }} - {{ order.from.state_abbr | upper }}</span>
            </div>
          </div>
          <div class="row row-1">
            <div>
              <span class="field-span">{{ order.from.postal_code | upper }}</span>
            </div>
          </div>
        </div>
        <div class="column brd-tl brd-r">
          <img src="../../../../images/shipping-companies/azulcargopb.png">
        </div>
      </div>
      <div class="block-1">
        <div class="row row-1">
          <div class="small-block brd-tl brd-r">
            <span class="field-span">Após imprimir:</span><br>
            <span class="field-span">CÓPIA DO AWB AZUL CARGO - SOLICITAMOS QUE COLOQUE UMA CÓPIA DO LADO DE DENTRO DA EMBALAGEM.</span>
          </div>
        </div>
      </div>
      <div class="block-1">
        <div class="row row-1">
          <div class="extra-large-block brd-tl brd-r">
            <span class="field-span">Declaro que:</span><br>
            <p class="field-span">
              O(s) volume(s) foi (foram) submetido(s) a controles de segurança apropriados até o momento da entrega à Azul Linhas Brasileiras S.A, ficando
              protegidos contra violação durante sua preparação para embarque, armazenamento e transporte; Até o momento da entrega à Azul Linhas
              Brasileiras S.A, o(s) volume(s) foi (foram) manuseado(s) por pessoas devidamente autorizadas e treinadas para identificar artigos proibidos e/ou
              perigosos para o transporte aéreo e nenhum deles apresenta restrição junto às autoridades policiais/criminais; O(s) volume(s) foi (foram)
              devidamente conferido(s), inspecionado(s) e estão de acordo com a descrição contida no documento fiscal correspondente, cujas informações
              integrarão o Conhecimento de Transporte Eletrônico – CTE; O(s) volume(s) está(ão) acondicionado(s) em embalagem(ns) adequada(s) para
              garantir a sua preservação durante o transporte até sua entrega ao destinatário; Quaisquer irregularidades identificadas no(s) volume(s) serão
              imediatamente comunicadas à Azul Linhas Brasileiras S.A. Afirmo que o(s) volume(s) apresentado(s) NÃO CONTÉM nenhum dos itens a seguir,
              pois estou ciente de que são PROIBIDOS PARA TRANSPORTE PELA AZUL: Artigo Perigoso à segurança do transporte aéreo (conforme
              classificação da ONU); Documentos para quaisquer modalidades de licitações e objetos sujeitos ao monopólio da União sobre os serviços
              postais e de telegramas; Artigo não aceito pela Azul Linhas Brasileiras S.A; Carga valor (acima de R$ 5.000,00 por quilo) ou vulnerável, sem
              autorização prévia da Azul Linhas Brasileiras S.A
            </p>
          </div>
        </div>
      </div>
      <div class="block-2">
        <div class="column brd-tl large-block">
          <span class="subtitle">Expedidor</span>
        </div>
        <div class="column brd-tl brd-r">
          <span class="subtitle">Recebedor</span>
        </div>
      </div>
      <div class="block-1 brd-l brd-r" style="border-bottom: 1px dashed;">
        <div class="row row-1" style="margin-bottom: 5px;">
          <div class="center-div">
            <span class="field-span" style="font-size: 0.7em;">(Dobre aqui)</span>
          </div>
        </div>
      </div>
      <div class="block-1 brd-l brd-r extra-small-block">
        <div class="row row-1">
          <div class="center-div" >
            <span class="field-span" style="font-size: 0.7em;">(Dobre aqui)</span>
          </div>
        </div>
      </div>

      <div class="block-2">
        <div class="column brd-l brd-r" v-if="order.service_id == 15">
          <img class="top-img" src="../../../../images/shipment/azul/amanha.png">
        </div>
        <div class="column brd-l brd-r" v-else>
          <img class="top-img" src="../../../../images/shipment/azul/ecommerce.png">
        </div>
        <div class="column brd-r brd-b">
          <div class="row row-1">
            <div>
              <span class="field-span font-uppercase">Destinatário</span>
            </div>
          </div>
          <div class="row row-1">
            <div>
              <span class="field-span">{{ order.to.name | upper }}</span>
            </div>
          </div>
          <div class="row row-1">
            <div>
              <span class="field-span">{{ order.to.address | upper }}, {{ order.to.location_number | upper }}</span>
            </div>
          </div>
          <div class="row row-1">
            <div>
              <span class="field-span">{{ order.to.complement | upper }}</span>
            </div>
          </div>
          <div class="row row-1">
            <div>
              <span class="field-span">{{ order.to.district | upper }}</span>
            </div>
          </div>
          <div class="row row-1">
            <div>
              <span class="field-span">{{ order.to.city | upper }} - {{ order.to.state_abbr | upper }}</span>
            </div>
          </div>
          <div class="row row-1">
            <div>
              <span class="field-span">{{ order.to.postal_code | upper }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="block-2">
        <div class="column brd-l brd-r brd-b">
            <div class="center-div">
              <canvas style="margin-top: -40px;" class="barcode417" ></canvas>
            </div>
        </div>
        <div class="column brd-r brd-t">
          <div class="row row-2">
            <div>
              <span class="field-span font-small">Data</span>
            </div>
            <div>
              <span class="field-span font-small">{{ moment().format('DD-MMM-YYYY') }}</span>
            </div>
          </div>
          <div class="row row-2">
            <div>
              <span class="field-span font-small">Peso</span>
            </div>
            <div>
              <span class="field-span font-small">{{ order.billed_weight }} KG</span>
            </div>
          </div>
          <div class="row row-2">
            <div>
              <span class="field-span font-small">Total Volumes</span>
            </div>
            <div>
              <span class="field-span font-small">{{ ("0000" + (groupVolumes.length)).slice(-4) }}</span>
            </div>
          </div>
          <div class="row row-2">
            <div>
              <span class="field-span font-small">Peso Taxado</span>
            </div>
            <div >
              <span class="field-span font-small">{{ order.billed_weight }} KG</span>
            </div>
          </div>
          <div class="row row-2">
            <div>
              <span class="field-span font-small">Nota Fiscal</span>
            </div>
            <div class="font-small">
              <template v-if="order.invoice && order.invoice.key">SIM</template>
              <template v-else>NÃO</template>
            </div>
          </div>
          <div class="row row-2">
            <div>
              <span class="field-span font-small">Quantidade de NF</span>
            </div>
            <div>
              <span class="field-span font-small" v-if="order.invoice && order.invoice.key">1</span>
              <span class="field-span font-small" v-else>0</span>
            </div>
          </div>
        </div>
      </div>

      <div class="block-2">
        <div class="column brd-l brd-r">
          <div class="row row-2">
            <div>
              <span class="field-span font-small">REF</span>
            </div>
            <div>
              <span class="field-span">00000 - GERAL</span>
            </div>
          </div>
          <div class="row row-2">
            <div>
              <span class="field-span font-small">DESC</span>
            </div>
            <div>
              <span v-if="order.to.note" class="field-span">{{ order.to.note}}</span>
              <span v-else class="field-span"></span>
            </div>
          </div>
        </div>
        <div class="column brd-r brd-t">
            <div class="row row-2">
            <div>
              <span class="field-span"></span>
            </div>
            <div>
              <span class="field-span"></span>
            </div>
          </div>
          <div class="row row-2">
            <div>
              <span class="field-span">CUSTOMER SIGN:</span>
            </div>
            <div>
              <span class="field-span"></span>
            </div>
          </div>
          <div class="row row-2">
            <div>
              <span class="field-span"></span>
            </div>
            <div class="center-div">
              <span class="field-span">_________________________</span>
            </div>
          </div>
          <div class="row row-2">
            <div>
              <span class="field-span" style="font-size: 0.7em;">Versão do Doc: 01.00</span>
            </div>
            <div class="center-div">
              <span class="field-span">{{ order.to.name | upper }}</span>
            </div>
          </div>
          <div class="row row-2 brd-b">
            <div>
              <span class="field-span"></span>
            </div>
            <div>
              <span class="field-span"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="block-2">
        <div class="column brd-l brd-r">
          <div class="row row-2">
            <div>
              <span class="field-span font-small">Tomador</span>
            </div>
            <div>
              <span class="field-span">Outro Tomador</span>
            </div>
          </div>
          <div class="row row-1">
            <div>
              <span class="field-span">CNPJ/CPF: {{ $options.static.cnpj }}</span>
            </div>
            <div>
              <span class="field-span">{{ $options.static.name }}</span>
            </div>
          </div>
        </div>
        <div class="column brd-r brd-t">
          <div class="row row-2">
            <div>
              <span class="field-span">TRK NUMBER #</span>
            </div>
            <div>
              <span class="field-span font-small">{{ minuta_code }}</span>
            </div>
          </div>
          <div class="row row-1">
            <div>
              <span class="field-span font-small">MASTER</span>
            </div>
            <div>
              <span class="field-span">BR-BR</span>
            </div>
          </div>
          <div class="row row-2">
            <div>
            </div>
            <div style="height: 0px;" v-if="order.service_id == 15">
              <img style="height: 42px; float:left; margin-top: -30px;" src="../../../../images/shipment/azul/amanha.png">
            </div>
            <div style="height: 0px;" v-else>
              <img style="height: 42px; float:left; margin-top: -30px;" src="../../../../images/shipment/azul/ecommerce.png">
            </div>
          </div>
        </div>
      </div>

      <div class="block-2">
        <div class="column brd-l brd-r brd-b">
          <div class="row row-2">
            <div>
              <span class="field-span font-small">Forma de Pagamento</span>
            </div>
            <div>
              <span class="field-span">C. COR.</span>
            </div>
          </div>
          <div class="row row-2">
            <div>
              <span class="field-span">VALOR DA MERCADORIA</span>
            </div>
            <div>
              <span class="field-span">{{ order.insurance_value | currency }}</span>
            </div>
          </div>
          <div class="row row-2">
            <div>
              <span class="field-span">SEGURO PRÓPRIO</span>
            </div>
            <div>
              <span class="field-span">NAO</span>
            </div>
          </div>
        </div>
        <div class="column brd-r brd-t brd-b">
          <div class="row row-2">
            <div>
              <div>
                <canvas class="barcode"
                  :data-text="minuta_code"
                  :data-value="minuta_code"
                  data-width="2"
                  data-height="50"
                  data-margin="0"
                  data-font="arial"
                  data-font-size="5"
                  data-textposition="bottom">
                </canvas>
              </div>
            </div>
            <div>
              <span class="field-span">ENTREGA DOMICILIO</span><br>
              <span class="field-span">NOR-NORMAL</span>
            </div>
        </div>
        </div>
      </div>
    </div>
    <div class="row row-3-1-1-2 mb-8" :key="index" v-for="(volume,index) in groupVolumes">
      <div class="minuta page-break-inside-avoid">
        <div class="block-2">
          <div class="column brd-tl">
            <div class="row row-1">
              <div>
                <span class="field-span font-uppercase">Remetente</span>
              </div>
            </div>
            <div class="row row-1">
              <div>
                <span class="field-span">{{ order.from.name | upper }}</span>
              </div>
            </div>
            <div class="row row-1">
              <div>
                <span class="field-span">{{ order.from.address | upper }}, {{ order.from.location_number | upper }}</span>
              </div>
            </div>
            <div class="row row-1">
              <div>
                <span class="field-span">{{ order.from.complement | upper }}</span>
              </div>
            </div>
            <div class="row row-1">
              <div>
                <span class="field-span">{{ order.from.district | upper }}</span>
              </div>
            </div>
            <div class="row row-1">
              <div>
                <span class="field-span">{{ order.from.city | upper }} - {{ order.from.state_abbr | upper }}</span>
              </div>
            </div>
            <div class="row row-1">
              <div>
                <span class="field-span">{{ order.from.postal_code | upper }}</span>
              </div>
            </div>
          </div>
          <div class="column brd-tl brd-r">
            <img src="../../../../images/shipping-companies/azulcargopb.png">
          </div>
        </div>
        <div class="block-1">
          <div class="row row-1">
            <div class="small-block brd-tl brd-r">
              <span class="field-span">Após imprimir:</span><br>
              <span class="field-span">CÓPIA DO AWB AZUL CARGO - SOLICITAMOS QUE COLOQUE UMA CÓPIA DO LADO DE DENTRO DA EMBALAGEM.</span>
            </div>
          </div>
        </div>
        <div class="block-1">
          <div class="row row-1">
            <div class="extra-large-block brd-tl brd-r">
              <span class="field-span">Declaro que:</span><br>
              <p class="field-span">
                O(s) volume(s) foi (foram) submetido(s) a controles de segurança apropriados até o momento da entrega à Azul Linhas Brasileiras S.A, ficando
                protegidos contra violação durante sua preparação para embarque, armazenamento e transporte; Até o momento da entrega à Azul Linhas
                Brasileiras S.A, o(s) volume(s) foi (foram) manuseado(s) por pessoas devidamente autorizadas e treinadas para identificar artigos proibidos e/ou
                perigosos para o transporte aéreo e nenhum deles apresenta restrição junto às autoridades policiais/criminais; O(s) volume(s) foi (foram)
                devidamente conferido(s), inspecionado(s) e estão de acordo com a descrição contida no documento fiscal correspondente, cujas informações
                integrarão o Conhecimento de Transporte Eletrônico – CTE; O(s) volume(s) está(ão) acondicionado(s) em embalagem(ns) adequada(s) para
                garantir a sua preservação durante o transporte até sua entrega ao destinatário; Quaisquer irregularidades identificadas no(s) volume(s) serão
                imediatamente comunicadas à Azul Linhas Brasileiras S.A. Afirmo que o(s) volume(s) apresentado(s) NÃO CONTÉM nenhum dos itens a seguir,
                pois estou ciente de que são PROIBIDOS PARA TRANSPORTE PELA AZUL: Artigo Perigoso à segurança do transporte aéreo (conforme
                classificação da ONU); Documentos para quaisquer modalidades de licitações e objetos sujeitos ao monopólio da União sobre os serviços
                postais e de telegramas; Artigo não aceito pela Azul Linhas Brasileiras S.A; Carga valor (acima de R$ 5.000,00 por quilo) ou vulnerável, sem
                autorização prévia da Azul Linhas Brasileiras S.A
              </p>
            </div>
          </div>
        </div>
        <div class="block-2">
          <div class="column brd-tl large-block">
            <span class="subtitle">Expedidor</span>
          </div>
          <div class="column brd-tl brd-r">
            <span class="subtitle">Recebedor</span>
          </div>
        </div>
        <div class="block-1 brd-l brd-r" style="border-bottom: 1px dashed;">
          <div class="row row-1" style="margin-bottom: 5px;">
            <div class="center-div">
              <span class="field-span" style="font-size: 0.7em;">(Dobre aqui)</span>
            </div>
          </div>
        </div>
        <div class="block-1 brd-l brd-r extra-small-block">
          <div class="row row-1">
            <div class="center-div" >
              <span class="field-span" style="font-size: 0.7em;">(Dobre aqui)</span>
            </div>
          </div>
        </div>

        <div class="block-2">
          <div class="column brd-l brd-r" v-if="order.service_id == 15">
            <img class="top-img" src="../../../../images/shipment/azul/amanha.png">
          </div>
          <div class="column brd-l brd-r" v-else>
            <img class="top-img" src="../../../../images/shipment/azul/ecommerce.png">
          </div>
          <div class="column brd-r brd-b">
            <div class="row row-1">
              <div>
                <span class="field-span font-uppercase">Destinatário</span>
              </div>
            </div>
            <div class="row row-1">
              <div>
                <span class="field-span">{{ order.to.name | upper }}</span>
              </div>
            </div>
            <div class="row row-1">
              <div>
                <span class="field-span">{{ order.to.address | upper }}, {{ order.to.location_number | upper }}</span>
              </div>
            </div>
            <div class="row row-1">
              <div>
                <span class="field-span">{{ order.to.complement | upper }}</span>
              </div>
            </div>
            <div class="row row-1">
              <div>
                <span class="field-span">{{ order.to.district | upper }}</span>
              </div>
            </div>
            <div class="row row-1">
              <div>
                <span class="field-span">{{ order.to.city | upper }} - {{ order.to.state_abbr | upper }}</span>
              </div>
            </div>
            <div class="row row-1">
              <div>
                <span class="field-span">{{ order.to.postal_code | upper }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="block-2">
          <div class="column brd-l brd-r brd-b">
              <div class="center-div">
                <canvas style="margin-top: -40px;" class="barcode417" ></canvas>
              </div>
          </div>
          <div class="column brd-r brd-t">
            <div class="row row-2">
              <div>
                <span class="field-span font-small">Data</span>
              </div>
              <div>
                <span class="field-span font-small">{{ moment().format('DD-MMM-YYYY') }}</span>
              </div>
            </div>
            <div class="row row-2">
              <div>
                <span class="field-span font-small">Peso Volume</span>
              </div>
              <div>
                <span class="field-span font-small">{{ volume.weight }} KG</span>
              </div>
            </div>
            <div class="row row-2">
              <div>
                <span class="field-span font-small">Peso Cubado</span>
              </div>
              <div>
                <span class="field-span font-small">{{ volume.cubic | cubic }}KG</span>
              </div>
            </div>
            <div class="row row-2">
              <div>
                <span class="field-span font-small">Dimensão</span>
              </div>
              <div >
                <span class="field-span font-small">DIMS {{ volume.length }} X {{ volume.width }} X {{ volume.height }} CM</span>
              </div>
            </div>
            <div class="row row-2">
              <div>
                <span class="field-span font-small"></span>
              </div>
              <div >
                <span class="field-span font-small"></span>
              </div>
            </div>
          </div>
        </div>

        <div class="block-2">
          <div class="column brd-l brd-r">
            <div class="row row-2">
              <div>
                <span class="field-span font-small">REF</span>
              </div>
              <div>
                <span class="field-span">00000 - GERAL</span>
              </div>
            </div>
            <div class="row row-2">
              <div>
                <span class="field-span font-small">DESC</span>
              </div>
              <div>
                <span v-if="order.to.note" class="field-span">{{ order.to.note}}</span>
                <span v-else class="field-span"></span>
              </div>
            </div>
          </div>
          <div class="column brd-r brd-t">
              <div class="row row-2">
              <div>
                <span class="field-span"></span>
              </div>
              <div>
                <span class="field-span"></span>
              </div>
            </div>
            <div class="row row-2 brd-b">
              <div>
                <span class="field-span"></span>
              </div>
              <div>
                <span class="field-span"></span>
              </div>
            </div>
          </div>
        </div>
        <div class="block-2">
          <div class="column brd-l brd-r">
            <div class="row row-2">
              <div>
                <span class="field-span font-small">Tomador</span>
              </div>
              <div>
                <span class="field-span">Outro Tomador</span>
              </div>
            </div>
            <div class="row row-1">
              <div>
                <span class="field-span">CNPJ/CPF: {{ $options.static.cnpj }}</span>
              </div>
              <div>
                <span class="field-span">{{ $options.static.name }}</span>
              </div>
            </div>
          </div>
          <div class="column brd-r brd-t">
            <div class="row row-2">
              <div>
                <span class="field-span">TRK NUMBER #</span>
              </div>
              <div>
                <span class="field-span font-small">{{ minuta_code }}</span>
              </div>
            </div>
            <div class="row row-1">
              <div>
                <span class="field-span font-small">{{ ("0000" + (index+1)).slice(-4) }}/{{ ("0000" + groupVolumes.length).slice(-4) }}</span>
              </div>
              <div>
                <span class="field-span">BR-BR</span>
              </div>
            </div>
            <div class="row row-2">
              <div>
              </div>
              <div style="height: 0px;" v-if="order.service_id == 15">
                <img style="height: 42px; float:left; margin-top: -30px;" src="../../../../images/shipment/azul/amanha.png">
              </div>
              <div style="height: 0px;" v-else>
                <img style="height: 42px; float:left; margin-top: -30px;" src="../../../../images/shipment/azul/ecommerce.png">
              </div>
            </div>
          </div>
        </div>

        <div class="block-2">
          <div class="column brd-l brd-r brd-b">
            <div class="row row-2">
              <div>
                <span class="field-span font-small">Forma de Pagamento</span>
              </div>
              <div>
                <span class="field-span">C. COR.</span>
              </div>
            </div>
            <div class="row row-2">
              <div>
                <span class="field-span">VALOR DA MERCADORIA</span>
              </div>
              <div>
                <span class="field-span">{{ order.insurance_value | currency }}</span>
              </div>
            </div>
            <div class="row row-2">
              <div>
                <span class="field-span">SEGURO PRÓPRIO</span>
              </div>
              <div>
                <span class="field-span">NAO</span>
              </div>
            </div>
          </div>
          <div class="column brd-r brd-t brd-b">
            <div class="row row-2">
              <div>
                <div>
                  <canvas class="barcode"
                    :data-text="minuta_code, index | addMinutaCodeVolumIndex"
                    :data-value="minuta_code, index | addMinutaCodeVolumIndex"
                    data-width="2"
                    data-height="50"
                    data-margin="0"
                    data-font="arial"
                    data-font-size="5"
                    data-textposition="bottom">
                  </canvas>
                </div>
              </div>
              <div>
                <span class="field-span">ENTREGA DOMICILIO</span><br>
                <span class="field-span">NOR-NORMAL</span>
              </div>
          </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  import PDF417 from "pdf417-generator";
  import { ME_CNPJ, ME_NAME } from '../../config/cnpj';

  export default {
    props: {
      order: {
        type: Object,
        required: true
      }
    },

    methods: {
      moment
    },

    static: {
      cnpj: ME_CNPJ,
      name: ME_NAME
    },

    computed: {
      minuta_code: function () {
        if (!this.order.tracking) {
          return '';
        }
        return String(this.order.tracking.replace(/[^0-9\.]+/g, ''));
      },
      groupVolumes: function () {
       const volumesGroup = this.order.volumes.map((a, b) => {
         return {
           ...a,
           cubic: (a.height * a.length * a.width) / 6000
         };
       });
       return volumesGroup;
      }
    },

    filters: {
      addMinutaCodeVolumIndex(value, index){
        return value + ("0000" + (index+1)).slice(-4);
      },
      currency(value, currency = 'R$', hasZero = true) {
        value = String(value);
        let matches = value.match(/(\,|\.)(\d{2})$/);
        if (matches && matches.length >= 3) {
          value = value.substr(0, value.length - 3).replace(/\D/g, '') + '.' + matches[2];
        }
        value = parseFloat(value);
        if (!(value && !isNaN(value) && isFinite(value))) value = 0;
        if (!hasZero && !value) return '-';
        return currency + ' ' + Number(value).toLocaleString('pt-BR', {
          currency: 'BRL',
          minimumFractionDigits: 2
        });
      },
      upper(text) {
        return String(text || '').toUpperCase();
      },
      cubic: function (value) {
        value = parseFloat(value.toFixed(2));
        return String(value).replace('.', ',');
      },
    },

    created() {
      moment.locale('pt_br');
    },

    mounted() {
      BarCode('.barcode').init();

      var canvas = document.getElementsByClassName("barcode417")
      for (var i = 0; i < canvas.length; i++) {
        if(i > 0){
          var code = "O:" + this.order.from.state_abbr + " " + this.order.from.city + "\n" +
            "D:" + this.order.to.state_abbr + " " + this.order.to.city + "\n" +
            "T:" + this.minuta_code + "Q:"+ ("0000" + (this.order.volumes.length)).slice(-4) +"\n"+
            "M:0V:"+this.minuta_code + ("0000" + (i)).slice(-4)+"\n";
        }else{
          var code = "O:" + this.order.from.state_abbr + " " + this.order.from.city + "\n" +
            "D:" + this.order.to.state_abbr + " " + this.order.to.city + "\n" +
            "T:" + this.minuta_code + "Q:"+ ("0000" + (this.order.volumes.length)).slice(-4) +"\n"+
            "M:1V:000000000000000\n";
        }
        PDF417.draw(code, canvas[i], 2, 6)
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .minuta
    margin-top 10px !important
    padding 10px
    font-family Arial, 'Open Sans', sans-serif
    img
      height 70px
      justify-self center
      align-self center
    .other-img
      height 110px
      justify-self center
      align-self center
  .top-img
    margin-top -50px
  .barcode
    transform: scale(.7) !important
  .barcode417
    width 100%
  .grid
    display grid
  .block-1-2
    display grid
    grid-template-columns 1fr 2fr
  .block-2
    display grid
    grid-template-columns 1fr 1fr
  .column
    display grid
    padding 8px
  .large-block
    height 80px
    & > div
      padding 8px
      box-sizing border-box
  .extra-large-block
    height 190px
  .big-block
    height 50px
  .medium-block
    height 40px
  .small-block
    height 33px
  .extra-small-block
    height 20px
  .row
    display inherit
  .row-1
    display grid
  .row-2
    grid-template-columns 1fr 1fr
  .row-2-1
    grid-template-columns 2fr 1fr
  .row-2-1-1
    grid-template-columns 2fr 1fr 1fr
  .row-3
    grid-template-columns 1fr 1fr 1fr
  .row-3-2
    grid-template-columns 3fr 2fr
  .row-3-1-1-2
    grid-template-columns 3fr 1fr 1fr 2fr
  .row-4-2
    grid-template-columns 4fr 2fr
  .mt-16
    margin-top 16px
  .mb-8
    margin-bottom 8px
  .no-border
    border none !important
  .brd-l
    border-left 1px solid #000
  .brd-tl
    border-top 1px solid #000
    border-left 1px solid #000
  .brd-r
    border-right 1px solid #000
  .brd-b
    border-bottom 1px solid #000
  .brd-all
    border 1px solid #000

  .field-span
    margin-top 4px
    margin-left 4px
    font-size 12px
  .center-span
    align-self center
  .subtitle
    margin-top 16px
    margin-bottom 4px
    display block
    font-size 12px
  .small-span
    font-size 8px
  .center
    text-align center
    font-size 16px
  .center-div
    text-align center
  .field-selector
    display block
    margin 2px 25px 0
  .font-medium
    font-size: 1.4em
    font-weight: bold
  .font-small
    font-size: 1em
    font-weight: bold
  .font-uppercase
    text-transform uppercase
</style>
